import { render, staticRenderFns } from "./ChangePrimaryDomainForm.vue?vue&type=template&id=0676548e&scoped=true&"
import script from "./ChangePrimaryDomainForm.vue?vue&type=script&lang=js&"
export * from "./ChangePrimaryDomainForm.vue?vue&type=script&lang=js&"
import style0 from "./ChangePrimaryDomainForm.vue?vue&type=style&index=0&id=0676548e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0676548e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0676548e')) {
      api.createRecord('0676548e', component.options)
    } else {
      api.reload('0676548e', component.options)
    }
    module.hot.accept("./ChangePrimaryDomainForm.vue?vue&type=template&id=0676548e&scoped=true&", function () {
      api.rerender('0676548e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ChangePrimary/ChangePrimaryDomainForm.vue"
export default component.exports